import React, { useState, useEffect } from "react";
import { useNavigate,Link } from "react-router-dom";
import {
  Layout,
  Form,
  Collapse,
  Button,
  Spin,
  Switch,
  Breadcrumb
} from "antd";
import {
  RightSquareOutlined,
  EditOutlined,
  LeftSquareOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const { Content, Sider } = Layout;

const { Panel } = Collapse;
const UserRoleList = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null); 
  const [groupResponse, setGroupResponse] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;

  const manageUserSteps = async () => {
    setLoading(true);
    try {
      let apiResponse = await getRequest(
        `create-group-permissions/get-group-permission-by-user/`
      );

      if (apiResponse.status === 200) {
        setGroupResponse(apiResponse.data.response.user_group_permissions);
      }
      setLoading(false);
    } catch (error) {
      setLoading(true);
    }
  };

  useEffect(() => {
    manageUserSteps();
  }, []);
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);

    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  useEffect(() => {
    if (groupResponse.length > 0) {
      const firstGroupName = groupResponse[0].group_name;
      const firstGroupId = groupResponse[0].group_id;
      setSelectedGroup(firstGroupName);
      setSelectedGroupId(firstGroupId);
    }
  }, [groupResponse]);

  const colors = ["#094E8F"];



  const groupedFamilies = groupResponse.reduce((acc, group) => {
    const family = group.group_role_family;
    if (!acc[family]) {
      acc[family] = [];
    }
    acc[family].push({ name: group.group_name, id: group.group_id });
    return acc;
  }, {});

  const selectedGroupData = groupResponse.find(
    (group) => group.group_name === selectedGroup
  );
  const selectedGroupPermissions = selectedGroupData?.permissions || [];

  const onGroupNameClick = (groupId, groupName) => {
    setSelectedGroup(groupName);
    setSelectedGroupId(groupId); 
  };
  const groupedPermissions = selectedGroupPermissions.reduce(
    (acc, permission) => {
      const modelName = permission.model_name;
      if (!acc[modelName]) {
        acc[modelName] = [];
      }
      acc[modelName].push(permission);
      return acc;
    },
    {}
  );

  const handleSubmit = () => {
    updateSubscriptionStatus();
    navigate("/manage-user-step");
  };

  function formatModelName(modelName) {
    return modelName
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <>
       <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                <h3>Manage User Group</h3>
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
    
                  <Breadcrumb.Item>Manage User Group</Breadcrumb.Item>
                </Breadcrumb>
                </div>
              <div className="pgnmbtns">
  <Button
                    className="usericon"
                    style={{
                      color: "#094E8F",
                      fontWeight: "500",
                    }}
                    icon={<PlusCircleOutlined />}
                    onClick={() => navigate("/user-role/add")}
                  >
                    Add New User Group
                  </Button>
              </div>
              
            </div>
          </div>
      
   <Content className="stepscontentwrap" >
                   {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
              <div className="stepsContent" >
                <div className="formwrapper" style={{height:'100%'}}>
                   <Spin spinning={loading}>
                  <div className="custometabswrap">
                    <div className="usersiderwrp">
                      <Sider
                        className="tabscolumn"
                        width={292}
                        breakpoint="lg"
                        collapsedWidth="0"
                        trigger={null}
                        collapsible
                        collapsed={collapsed}
                      >
                        
                        {Object.entries(groupedFamilies).map(
                          ([family, groups], index) => {
                            return (
                              <div key={index}>
                                <h3>{family === "null" ? "" : family}</h3>
                                <ul>
                                  {groups.map((group, idx) => (
                                    <li
                                      className={
                                        group.name === selectedGroup
                                          ? "active"
                                          : ""
                                      }
                                      key={group.id}
                                      onClick={() =>
                                        onGroupNameClick(group.id, group.name)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {group.name}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            );
                          }
                        )}
                      </Sider>
                      <div className="siderarrowcol">
                        {React.createElement(
                          collapsed ? RightSquareOutlined : LeftSquareOutlined,
                          {
                            className: "trigger",
                            onClick: () => setCollapsed(!collapsed),
                          }
                        )}
                      </div>
                    </div>
                    <div className="tabscontent" style={{overflow:'visible'}}>
                      <div className="tobtnwrap">
                        {selectedGroupId !== null ? (
                          <Button
                            icon={<EditOutlined />}
                            onClick={() =>
                              navigate(
                                "/user-role/edit/" + btoa(selectedGroupId)
                              )
                            }
                          >
                            Edit
                          </Button>
                        ) : (
                          ""
                        )}
                      </div>
                      {selectedGroup && (
                        <Collapse defaultActiveKey={["0"]}>
                          {Object.entries(groupedPermissions).map(
                            ([modelName, permissions], index) => (
                              <Panel
                                header={formatModelName(modelName)}
                                key={index}
                              >
                                {permissions.map((permission, idx) => (
                                  <div
                                    className="permissionlist TextFeild"
                                    key={idx}
                                  >
                                    <Form.Item className="radioitem">
                                      <Switch
                                        checked={permission.is_checked}
                                        disabled
                                      />
                                    </Form.Item>
                                    {permission.name}
                                  </div>
                                ))}
                              </Panel>
                            )
                          )}
                        </Collapse>
                      )}
                    </div>
                  </div>
                     </Spin>
                </div>
              </div>
             
            </Content>
      
     
        
         
         
       
   
    </>
  );
};

export default UserRoleList;
